<script setup lang="ts">
withDefaults(defineProps<{
  html?: string
}>(), {
  html: ''
})
</script>

<template>
  <div class="bx-content bx-typo--content-intro bx-content__intro bx-content__continuous-text bx-typo--content-continuous-text"
       v-html="html" />
</template>
